import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  user,
  domain,
  chart,
}) => new Promise((resolve) => {
  nsApi.get({
    object: 'chart',
    action: 'delete',
    domain,
    user,
    id: chart.id,
    dashboard_id: chart.dashboard_id,
  }).then((res) => {
    resolve(res);
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
